import React from "react";
import UsersListRow from "./UsersListRow";

const UsersList = (props) => {
  const { users, addTab, handleDropDownChange } = props;

  return (
    <div className="flex flex-col gap-[1.375rem] pt-[1.375rem] h-full max-h-[90%] overflow-auto box-border ">
      {Array.isArray(users) && users.length > 0 ? (
        users.map((user, index) => (
          <UsersListRow
            user={user}
            index={index}
            handleDropDownChange={(index, name, value) =>
              handleDropDownChange(index, name, value)
            }
            key={user.userID ?? "not-unique"}
            handleClick={(userID) => addTab("user", userID)}
            onRowClick={(index) => props.onRowClick(index)}
          />
        ))
      ) : (
        <p className="text-white">No users found.</p>
      )}
    </div>
  );
};

export default UsersList;
